import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { auth, db } from './firebase';
import AddClient from './pages/AddClient';
import Admin from './pages/Admin';
import AdminProfile from './pages/AdminProfile';
import AdminMessage from './pages/AdminMessage';
import Broadcast from './pages/Broadcast';
import Clients from './pages/Clients';
import Consent from './pages/Consent';
import Dashboard from './pages/Dashboard';
import EditClient from './pages/EditClient';
import ImportClients from './pages/ImportClients';
import SendClientLinks from './pages/SendClientLinks';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Setup from './pages/Setup';
import Welcome from './pages/Welcome';

function PrivateRoute({ children }) {
  const [user, setUser] = useState(undefined);
  const [hasSeenWelcome, setHasSeenWelcome] = useState(undefined);
  const [consentAccepted, setConsentAccepted] = useState(undefined);
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminChecked, setAdminChecked] = useState(false);
  const [agentName, setAgentName] = useState('');
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (!u) {
        setIsAdmin(false);
        setAdminChecked(true);
        setHasSeenWelcome(false);
        setConsentAccepted(false);
        return;
      }
      try {
        const tok = await u.getIdTokenResult();
        setIsAdmin(tok.claims.admin === true);
      } catch (e) {
        setIsAdmin(false);
      } finally {
        setAdminChecked(true);
      }
      try {
        const agentSnap = await getDoc(doc(db, 'agents', u.uid));
        if (agentSnap.exists()) {
          const data = agentSnap.data();
          setHasSeenWelcome(data.hasSeenWelcome === true);
          setConsentAccepted(data.consentAccepted === true);
          setAgentName(data.name || '');
        } else {
          setHasSeenWelcome(false);
          setConsentAccepted(false);
        }
      } catch (err) {
        console.error('Error checking agent doc:', err);
        setHasSeenWelcome(true);
        setConsentAccepted(true);
      }
    });
    return unsubscribe;
  }, []);

  if (user === undefined || (user && (!adminChecked || hasSeenWelcome === undefined || consentAccepted === undefined))) {
    return <div style={{ padding: 40 }}>Loading...</div>;
  }

  if (!user) return <Navigate to="/login" />;

  if (!isAdmin && !consentAccepted) {
    return <Consent agentName={agentName} onComplete={() => setConsentAccepted(true)} />;
  }
  if (!isAdmin && !hasSeenWelcome) {
    return <Welcome agentName={agentName} onComplete={() => setHasSeenWelcome(true)} />;
  }

  if (isAdmin && location.pathname !== '/admin' && location.pathname !== '/admin-profile' && location.pathname !== '/admin-message') {
    return <Navigate to="/admin" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/clients" element={<PrivateRoute><Clients /></PrivateRoute>} />
        <Route path="/add-client" element={<PrivateRoute><AddClient /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/edit-client/:clientId" element={<PrivateRoute><EditClient /></PrivateRoute>} />
        <Route path="/broadcast" element={<PrivateRoute><Broadcast /></PrivateRoute>} />
        <Route path="/import-clients" element={<PrivateRoute><ImportClients /></PrivateRoute>} />
          <Route path="/send-client-links" element={<PrivateRoute><SendClientLinks /></PrivateRoute>} />
        <Route path="/setup" element={<PrivateRoute><Setup /></PrivateRoute>} />
        <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
        <Route path="/admin-profile" element={<PrivateRoute><AdminProfile /></PrivateRoute>} />
        <Route path="/admin-message" element={<PrivateRoute><AdminMessage /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;






